module.exports = __webpack_public_path__ + "img/icon_finish.d62c22d8.svg";